export function isValidEmail(email: string): boolean {
  // Regular expression for a valid email address
  const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

  // Test the email against the regex pattern
  return emailRegex.test(email);
}
